import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import Login from "./pages/auth/Login";
import Me from "./pages/Me";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import ProtectedRouteAuth from "./protectedRoutes/Auth";
import ProtectedRouteUser from "./protectedRoutes/User";
import { useAppSelector } from "./redux/store";
import ListInvoice from "./pages/Invoice";
import InvoiceDetail from "./pages/Invoice/Detail";
import User from "./pages/User";
import ListQuotation from "./pages/Quotation";
import QuotationDetail from "./pages/Quotation/Detail";
import InvoiceSetting from "./pages/Invoice/Setting";
import QuotationSetting from "./pages/Quotation/Setting";
import ListPaymentDetail from "./pages/PaymentDetail";
import ListSignature from "./pages/Signature";
import ListSignatureBackground from "./pages/SignatureBackground";

export const AppRoutes = () => {
  const { isFetched, isLogin } = useAppSelector((state) => state.auth);

  if (!isFetched) {
    return <Spinner />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRouteAuth isLoggedIn={isLogin} />}>
          <Route path="/signin" element={<Login />} />
        </Route>
        <Route element={<ProtectedRouteUser isLoggedIn={isLogin} />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/user" element={<User />} />
          <Route path="/invoice" element={<ListInvoice />} />
          <Route path="/invoice/:invoiceId" element={<InvoiceDetail />} />
          <Route path="/invoice-setting" element={<InvoiceSetting />} />
          <Route path="/quotation" element={<ListQuotation />} />
          <Route path="/quotation/:quotationId" element={<QuotationDetail />} />
          <Route path="/quotation-setting" element={<QuotationSetting />} />
          <Route path="/payment-detail" element={<ListPaymentDetail />} />
          <Route path="/signature" element={<ListSignature />} />
          <Route path="/signature-background" element={<ListSignatureBackground />} />
          <Route path="/me" element={<Me />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
